import { Component, OnInit } from '@angular/core';
import { UserProfileService } from './service/user-profile.service';
import { UserProfile } from './interface/user-profile';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css'],
})
export class UserProfileComponent implements OnInit {
  user: UserProfile | null = null;
  isLoading = true;
  errorMessage: string | null = null;
  mode: 'edit' | 'view' = 'view';
  userId: string | null = null;

  constructor(
    private userprofileService: UserProfileService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  /**
   * Called when profile-header emits the updated profile response.
   * Replaces the parent user object so all child components (skills,
   * contact, completion) automatically reflect the new data.
   */
  onProfileUpdated(updatedUser: UserProfile): void {
    this.user = { ...updatedUser };
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.userId = params['userId'];
    });
    if (this.userId && !this.userprofileService.getRole()) {
      this.mode = 'view';
      this.userprofileService.getApplicantProfile(this.userId).subscribe({
        next: (res: UserProfile) => {
          this.user = res;
          this.isLoading = false;
        },

        error: (err) => {
          this.errorMessage = 'Failed to load user profile';
          this.isLoading = false;
        },
      });
    } else if (this.userprofileService.getRole()) {
      this.mode = 'edit';
      this.userprofileService.getUserProfile().subscribe({
        next: (res: UserProfile) => {
          this.user = res;
          this.isLoading = false;
        },
        error: (err) => {
          this.errorMessage = 'Failed to load user profile';
          this.isLoading = false;
        },
      });
    } else {
      this.router.navigate(['company-admin/company-profile']);
    }
  }
}
